import { FieldOption, GovernanceField } from './types'

export const getInitialSelected = (options: FieldOption[], selectedFields: GovernanceField[]) =>
  selectedFields
    .filter(selectedField =>
      options.some(field => field.id === selectedField.concatenation_field_id),
    )
    .map(selectedField => ({
      ...selectedField,
      concatenation_field_name: getFieldNameFromOptions(
        options,
        selectedField.concatenation_field_id,
      ),
    }))
    .sort((a, b) => a.precedence - b.precedence)

// fields coming from governance_patterns don't have the name property, so I need to get it from the options
export const getFieldNameFromOptions = (options: FieldOption[], fieldId: string) =>
  options.find(field => field.id === fieldId)?.name || ''

export const reorderFields = (
  fields: GovernanceField[],
  startIndex: number,
  endIndex: number,
): GovernanceField[] => {
  const [removed] = fields.splice(startIndex, 1)

  if (!removed) {
    return fields
  }

  fields.splice(endIndex, 0, removed)

  // I had to change the precendece of the fields to match the index
  return fields.map((field, index) => ({ ...field, precedence: (field.precedence = index) }))
}
